import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CheckoutComponent } from './allpages/checkout/checkout.component';
// import { HomeComponent } from './allpages/home/home.component';
import { TestComponent } from './allpages/test/test.component';
import { AboutUsModule } from './allpages/about-us/about-us.module';
import { NewHomeComponent } from './allpages/new-home/new-home.component';

const routes: Routes = [
    // { path: '', component: HomeComponent },
    {
        path: '',
        loadChildren: () =>
            import('./allpages/new-home/new-home.module').then(
                (m) => m.NewHomeModule
            ),
    },
    { path: 'home', redirectTo: '' },
    { path: 'search-cuisine/book-your-order', redirectTo: '' },
    { path: 'search-cuisine/book-your-order/:location/:cusisne_name', redirectTo: '' },
    { path: 'zappetite', redirectTo: 'party-packs' },
    { path: 'our-story', redirectTo: 'about-us' },
    
    // {
    //     path: 'home',
    //     loadChildren: () =>
    //         import('./allpages/home/home.module').then((m) => m.HomeModule),
    // },
    {
        path: 'about-us',
        loadChildren: () =>
            import('./allpages/about-us/about-us.module').then(
                (m) => m.AboutUsModule
            ),
    },
    {
        path: 'party-packs',
        loadChildren: () =>
            import('./allpages/chef-profile/chef-profile.module').then(
                (m) => m.ChefProfileModule
            ),
    },

    {
        path: 'home',
        loadChildren: () =>
            import('./allpages/new-home/new-home.module').then(
                (m) => m.NewHomeModule
            ),
    },

    { path: 'checkout', component: CheckoutComponent },
    // { path: 'test', component: TestComponent },

    // {
    //     path: 'our-story',
    //     loadChildren: () =>
    //         import('./allpages/our-story/our-story.module').then(
    //             (m) => m.OurStoryModule
    //         ),
    // },
    {
        path: 'become-a-chef',
        loadChildren: () =>
            import('./allpages/become-a-chef/become-a-chef.module').then(
                (m) => m.BecomeAChefModule
            ),
    },
    // {
    //     path: 'search-cuisine/book-your-order',
    //     loadChildren: () =>
    //         import('./allpages/search-page/search-page.module').then(
    //             (m) => m.SearchPageComponentModule
    //         ),
    // },
    // {
    //     path: 'search-cuisine/book-your-order/Delhi',
    //     loadChildren: () =>
    //         import(
    //             './allpages/searchpagelocation/searchpagelocation.module'
    //         ).then((m) => m.SearchpagelocationModule),
    // },
    // {
    //     path: 'search-cuisine/book-your-order/delhi',
    //     loadChildren: () =>
    //         import(
    //             './allpages/searchpagelocation/searchpagelocation.module'
    //         ).then((m) => m.SearchpagelocationModule),
    // },
    // {
    //     path: 'search-cuisine/book-your-order/Gurgaon',
    //     loadChildren: () =>
    //         import(
    //             './allpages/searchpagelocation/searchpagelocation.module'
    //         ).then((m) => m.SearchpagelocationModule),
    // },
    // {
    //     path: 'search-cuisine/book-your-order/gurgaon',
    //     loadChildren: () =>
    //         import(
    //             './allpages/searchpagelocation/searchpagelocation.module'
    //         ).then((m) => m.SearchpagelocationModule),
    // },
    // {
    //     path: 'search-cuisine/book-your-order/Noida',
    //     loadChildren: () =>
    //         import(
    //             './allpages/searchpagelocation/searchpagelocation.module'
    //         ).then((m) => m.SearchpagelocationModule),
    // },
    // {
    //     path: 'search-cuisine/book-your-order/noida',
    //     loadChildren: () =>
    //         import(
    //             './allpages/searchpagelocation/searchpagelocation.module'
    //         ).then((m) => m.SearchpagelocationModule),
    // },
    // {
    //     path: 'search-cuisine/book-your-order/Bangalore',
    //     loadChildren: () =>
    //         import(
    //             './allpages/searchpagelocation/searchpagelocation.module'
    //         ).then((m) => m.SearchpagelocationModule),
    // },
    // {
    //     path: 'search-cuisine/book-your-order/bangalore',
    //     loadChildren: () =>
    //         import(
    //             './allpages/searchpagelocation/searchpagelocation.module'
    //         ).then((m) => m.SearchpagelocationModule),
    // },
    // {
    //     path: 'search-cuisine/book-your-order/gurgaon/DLF-Phase-2',
    //     loadChildren: () =>
    //         import(
    //             './allpages/searchpagelocation/searchpagelocation.module'
    //         ).then((m) => m.SearchpagelocationModule),
    // },
    // {
    //     path: 'search-cuisine/book-your-order/gurgaon/DLF-Cyber-City',
    //     loadChildren: () =>
    //         import(
    //             './allpages/searchpagelocation/searchpagelocation.module'
    //         ).then((m) => m.SearchpagelocationModule),
    // },
    // {
    //     path: 'search-cuisine/book-your-order/gurgaon/Sushant-Lok',
    //     loadChildren: () =>
    //         import(
    //             './allpages/searchpagelocation/searchpagelocation.module'
    //         ).then((m) => m.SearchpagelocationModule),
    // },
    // {
    //     path: 'search-cuisine/book-your-order/gurgaon/Golf-Course-Road',
    //     loadChildren: () =>
    //         import(
    //             './allpages/searchpagelocation/searchpagelocation.module'
    //         ).then((m) => m.SearchpagelocationModule),
    // },
    // {
    //     path: 'search-cuisine/book-your-order/gurgaon/MG-Road',
    //     loadChildren: () =>
    //         import(
    //             './allpages/searchpagelocation/searchpagelocation.module'
    //         ).then((m) => m.SearchpagelocationModule),
    // },
    // {
    //     path: 'search-cuisine/book-your-order/gurgaon/Nirvana-Country',
    //     loadChildren: () =>
    //         import(
    //             './allpages/searchpagelocation/searchpagelocation.module'
    //         ).then((m) => m.SearchpagelocationModule),
    // },
    // {
    //     path: 'search-cuisine/book-your-order/gurgaon/Sector-54',
    //     loadChildren: () =>
    //         import(
    //             './allpages/searchpagelocation/searchpagelocation.module'
    //         ).then((m) => m.SearchpagelocationModule),
    // },
    // {
    //     path: 'search-cuisine/book-your-order/gurgaon/Sector-42',
    //     loadChildren: () =>
    //         import(
    //             './allpages/searchpagelocation/searchpagelocation.module'
    //         ).then((m) => m.SearchpagelocationModule),
    // },
    // {
    //     path: 'search-cuisine/book-your-order/gurgaon/Palam-Vihar',
    //     loadChildren: () =>
    //         import(
    //             './allpages/searchpagelocation/searchpagelocation.module'
    //         ).then((m) => m.SearchpagelocationModule),
    // },
    // {
    //     path: 'search-cuisine/book-your-order/gurgaon/South-City',
    //     loadChildren: () =>
    //         import(
    //             './allpages/searchpagelocation/searchpagelocation.module'
    //         ).then((m) => m.SearchpagelocationModule),
    // },
    // {
    //     path: 'search-cuisine/book-your-order/delhi/Golf-Links',
    //     loadChildren: () =>
    //         import(
    //             './allpages/searchpagelocation/searchpagelocation.module'
    //         ).then((m) => m.SearchpagelocationModule),
    // },
    // {
    //     path: 'search-cuisine/book-your-order/delhi/Vasant-Vihar',
    //     loadChildren: () =>
    //         import(
    //             './allpages/searchpagelocation/searchpagelocation.module'
    //         ).then((m) => m.SearchpagelocationModule),
    // },
    // {
    //     path: 'search-cuisine/book-your-order/delhi/Greater-Kailash',
    //     loadChildren: () =>
    //         import(
    //             './allpages/searchpagelocation/searchpagelocation.module'
    //         ).then((m) => m.SearchpagelocationModule),
    // },
    // {
    //     path: 'search-cuisine/book-your-order/delhi/Sainik-Farms',
    //     loadChildren: () =>
    //         import(
    //             './allpages/searchpagelocation/searchpagelocation.module'
    //         ).then((m) => m.SearchpagelocationModule),
    // },
    // {
    //     path: 'search-cuisine/book-your-order/delhi/New-Friends-Colony',
    //     loadChildren: () =>
    //         import(
    //             './allpages/searchpagelocation/searchpagelocation.module'
    //         ).then((m) => m.SearchpagelocationModule),
    // },
    // {
    //     path: 'search-cuisine/book-your-order/delhi/Defence-Colony',
    //     loadChildren: () =>
    //         import(
    //             './allpages/searchpagelocation/searchpagelocation.module'
    //         ).then((m) => m.SearchpagelocationModule),
    // },
    // {
    //     path: 'search-cuisine/book-your-order/delhi/Vasant-Kunj',
    //     loadChildren: () =>
    //         import(
    //             './allpages/searchpagelocation/searchpagelocation.module'
    //         ).then((m) => m.SearchpagelocationModule),
    // },
    // {
    //     path: 'search-cuisine/book-your-order/delhi/South-Extension',
    //     loadChildren: () =>
    //         import(
    //             './allpages/searchpagelocation/searchpagelocation.module'
    //         ).then((m) => m.SearchpagelocationModule),
    // },
    // {
    //     path: 'search-cuisine/book-your-order/delhi/Green-Park',
    //     loadChildren: () =>
    //         import(
    //             './allpages/searchpagelocation/searchpagelocation.module'
    //         ).then((m) => m.SearchpagelocationModule),
    // },
    // {
    //     path: 'search-cuisine/book-your-order/delhi/Dwarka',
    //     loadChildren: () =>
    //         import(
    //             './allpages/searchpagelocation/searchpagelocation.module'
    //         ).then((m) => m.SearchpagelocationModule),
    // },
    // {
    //     path: 'search-cuisine/book-your-order/:location/:cusisne_name',
    //     loadChildren: () =>
    //         import(
    //             './allpages/searchpagecuisinelocation/searchpagecuisinelocation.module'
    //         ).then((m) => m.SearchpagecuisinelocationModule),
    // },
    // { path: 'search-cuisine/book-your-order/delhi/:cusisne_name', loadChildren: () => import('./allpages/searchpagecuisinelocation/searchpagecuisinelocation.module').then(m => m.SearchpagecuisinelocationModule) },
    // redirecting some duplicate urls
    // {
    //     path: 'search-cuisine/book-your-order/Mexican-Cuisine',
    //     redirectTo: 'search-cuisine/book-your-order/Mexican',
    // },
    // {
    //     path: 'search-cuisine/book-your-order/Whats-Trending',
    //     redirectTo: 'search-cuisine/book-your-order/Mexican',
    // },
    // {
    //     path: 'search-cuisine/book-your-order/Karnataka-Cuisine',
    //     redirectTo: 'search-cuisine/book-your-order/Karnataka',
    // },

    // {
    //     path: 'search-cuisine/book-your-order/:cusisne_name',
    //     loadChildren: () =>
    //         import('./allpages/search-ssr/search-ssr.module').then(
    //             (m) => m.SearchSsrModule
    //         ),
    // },
    // {
    //   path: 'search-cuisine/book-your-order',
    //   loadChildren: () => import('./allpages/search-ssr/search-ssr.module')
    //     .then(m => m.SearchSsrModule)
    // },

    {
        path: 'chefdetail',
        loadChildren: () =>
            import('./allpages/chef-profile/chef-profile.module').then(
                (m) => m.ChefProfileModule
            ),
    },
    {
        path: 'chefdetail/:chef_id',
        loadChildren: () =>
            import('./allpages/chef-profile/chef-profile.module').then(
                (m) => m.ChefProfileModule
            ),
    },
    {
        path: 'chefdetail/:chef_id/:cuisine_id',
        loadChildren: () =>
            import('./allpages/chef-profile/chef-profile.module').then(
                (m) => m.ChefProfileModule
            ),
    },

    // {
    //   path: 'blog',
    //   loadChildren: () => import('./allpages/blog/blog.module')
    //     .then(m => m.BlogModule)
    // },
    {
        path: 'customer-profile',
        loadChildren: () =>
            import('./allpages/customer-profile/customer-profile.module').then(
                (m) => m.CustomerProfileModule
            ),
    },
    {
        path: 'privacy-policy',
        loadChildren: () =>
            import('./allpages/privacy-policy/privacy-policy.module').then(
                (m) => m.PrivacyPolicyModule
            ),
    },
    {
        path: 'contact-us',
        loadChildren: () =>
            import('./allpages/contact-us/contact.module').then(
                (m) => m.ContactUsModule
            ),
    },
    {
        path: 'event-detail',
        loadChildren: () =>
            import('./allpages/event-detail/event-detail.module').then(
                (m) => m.EventDetailModule
            ),
    },
    {
        path: 'CheckoutComponent',
        loadChildren: () =>
            import('./allpages/checkout/checkout.module').then(
                (m) => m.CheckoutModule
            ),
    },
    {
        path: 'holi-promotion',
        loadChildren: () =>
            import('./allpages/promotion-page/promotion-page.module').then(
                (m) => m.PromotionPageModule
            ),
    },
    // {
    //     path: 'zappetite',
    //     loadChildren: () =>
    //         import('./allpages/landing-page/landing-page.module').then(
    //             (m) => m.LandingPageModule
    //         ),
    // },
    {
        path: 'diwali-packages',
        loadChildren: () =>
            import('./allpages/diwali-packages/diwali-packages.module').then(
                (m) => m.DiwaliPackagesModule
            ),
    },
    {
        path: 'thank-you',
        loadChildren: () =>
            import('./allpages/thank-you-page/thank-you-page.module').then(
                (m) => m.ThankYouPageModule
            ),
    },
    {
        path: 'order-detail',
        loadChildren: () =>
            import('./allpages/order-detail/order-detail.module').then(
                (m) => m.OrderDetailModule
            ),
    },
    // {
    //     path: 'chefdetail/:chef_id/:Location',
    //     loadChildren: () =>
    //         import(
    //             './allpages/chefdetaillocation/chefdetaillocation.module'
    //         ).then((m) => m.ChefdetaillocationModule),
    // },
    // {
    //     path: 'chefdetail/:chef_id/:Location/:menu_id',
    //     loadChildren: () =>
    //         import(
    //             './allpages/chefdetaillocation/chefdetaillocation.module'
    //         ).then((m) => m.ChefdetaillocationModule),
    // },

    // {
    //     path: 'chef-profile/:chef_id',
    //     loadChildren: () => import('./allpages/chef-profile/chef-profile.module').then((m) => m.ChefProfileModule)
    // }

    // { path: 'chefdetail/:chef_id/:Gurgaon', loadChildren: () => import('./allpages/chefdetaillocation/chefdetaillocation.module').then(m => m.ChefdetaillocationModule) },
    // { path: 'chefdetail/:chef_id/:Bangalore', loadChildren: () => import('./allpages/chefdetaillocation/chefdetaillocation.module').then(m => m.ChefdetaillocationModule) },
    // { path: 'chefdetails', loadChildren: () => import('./allpages/chefdetaillocation/chefdetaillocation.module').then(m => m.ChefdetaillocationModule) },

    // { path: 'searchSsr', loadChildren: () => import('./allpages/search-ssr/search-ssr.module').then(m => m.SearchSsrModule) },
    // { path: '**', component: HomeComponent },
    // { path: 'event-detail/:id', component: EventDetailComponent },

    { path: '**', redirectTo: '', pathMatch: 'full' }
];

@NgModule({
    // imports: [RouterModule.forRoot(routes, {useHash: true})],
    imports: [
        RouterModule.forRoot(routes, {
            initialNavigation: 'enabled',
        }),
    ],
    exports: [RouterModule],
})
export class AppRoutingModule {}
